import {
  LOADING_COMPOSERS,
  LOADING_DATA,
  SET_SHEETS,
  SET_COMPOSERS,
  RESET_DATA,
  SET_PAGE_SHEETS,
  INCREMENT_SHEET_PAGE,
  DECREMENT_SHEET_PAGE,
  SET_SHEET_PAGE,
  SET_TOTAL_SHEET_PAGES,
  SET_TOTAL_COMPOSER_PAGES,
  INCREMENT_COMPOSER_PAGE,
  DECREMENT_COMPOSER_PAGE,
  SET_COMPOSER_PAGE,
  SET_PAGE_COMPOSERS,
  SET_USERS_DATA,
  UPDATE_SHEET_DATA,
  UPDATE_COMPOSER_DATA,
} from "../types";

const initialState = {
  sheets: [],
  composers: [],

  sheetPages: {},
  composerPages: {},
  
  sheet: [],
  composer: [],

  sheetPage: 1,
  composerPage: 1,

  totalSheetPages: 1,
  totalComposerPages: 1,
  
  composerSortOrder: "name_asc",
  composerViewMode: "gallery",

  sheetSortOrder: "name_asc",
  sheetViewMode: "gallery",
  
  entrysPerComposerPage: 25,
  entrysPerSheetPage: 25,

  usersData: [],

  loading: false,
};

// ⭐ Funktion benannt ("dataReducer"), um anonymen Export-Fehler zu beheben
function dataReducer(state = initialState, action) {
  switch (action.type) {
    case LOADING_DATA:
      return {
        ...state,
        loading: true,
      };

    case SET_TOTAL_SHEET_PAGES:
      return {
        ...state,
        totalSheetPages: action.payload,
      };

    case SET_TOTAL_COMPOSER_PAGES:
      return {
        ...state,
        totalComposerPages: action.payload,
      };

    case INCREMENT_SHEET_PAGE:
      return {
        ...state,
        sheetPage: state.sheetPage + 1,
      };

    case INCREMENT_COMPOSER_PAGE:
      return {
        ...state,
        composerPage: state.composerPage + 1,
      };

    case DECREMENT_SHEET_PAGE:
      return {
        ...state,
        sheetPage: state.sheetPage - 1,
      };

    case DECREMENT_COMPOSER_PAGE:
      return {
        ...state,
        composerPage: state.composerPage - 1,
      };

    case SET_SHEET_PAGE:
      return {
        ...state,
        sheetPage: action.payload,
      };

    case SET_COMPOSER_PAGE:
      return {
        ...state,
        composerPage: action.payload,
      };

    case SET_PAGE_SHEETS:
      if (action.composer === undefined) {
        return {
          ...state,
          loading: false,
          sheetPages: { ...state.sheetPages, [action.page]: action.payload },
        };
      }

      for (let key in state.composerPages) {
        if (!state.composerPages.hasOwnProperty(key)) continue;
        const page = state.composerPages[key];
        const result = page.find(
          (composer) => composer.safe_name === action.composer
        );

        if (result !== undefined) {
          var index = page.indexOf(result);

          if (index !== -1) {
            page[index] = { ...page[index], sheets: action.payload };
          }

          return {
            ...state,
            loading: false,
            composerPages: {
              ...state.composerPages,
              [state.composerPages[key]]: page,
            },
          };
        }
      }
      break;

    case SET_PAGE_COMPOSERS:
      return {
        ...state,
        loading: false,
        composerPages: {
          ...state.composerPages,
          [action.page]: action.payload,
        },
      };

    case SET_SHEETS:
      return {
        ...state,
        sheets: action.payload,
        loading: false,
      };

    case LOADING_COMPOSERS:
      return {
        ...state,
        loading: true,
      };

    case SET_COMPOSERS:
      return {
        ...state,
        composers: action.payload,
        loading: false,
      };
    
    case SET_USERS_DATA:
      return {
        ...state, // ⭐ Fehler behoben: ...state.composerPage zu ...state korrigiert
        usersData: action.payload,
        loading: false
      };
	
	case "UPDATE_SHEET_RATING":
      return {
        ...state,
        // Wir mappen durch die Sheets und aktualisieren nur das eine passende
        sheets: state.sheets.map((sheet) =>
          sheet.safeSheetName === action.payload.safeSheetName
            ? {
                ...sheet,
                RatingAvg: action.payload.ratingAvg,    // Matcht dein Go JSON-Tag
                ratingCount: action.payload.ratingCount, // Matcht dein Go JSON-Tag
              }
            : sheet
        ),
      };

	case UPDATE_COMPOSER_DATA:
	  return {
		...state,
		// 👍 Überschreibt einfach nur das aktive Composer-Objekt im globalen Store
		composer: action.payload,
		loading: false
	  };
	   
	case UPDATE_SHEET_DATA: {
      // 1. Sicherstellen, dass wir gültige Objekte aus dem Payload ziehen
      const payloadData = action.payload || {};
      const payloadName = payloadData.safe_sheet_name || payloadData.safeSheetName || "";

      return {
        ...state,
        // Das einzelne aktive Sheet im State aktualisieren
        sheet: state.sheet ? {
          ...state.sheet,
          ...payloadData
        } : payloadData,

        // ⭐ FIX: Wenn state.sheets nicht existiert, nehmen wir das bestehende state.sheets (oder ein leeres Array),
        // weigern uns aber strikt, eine bestehende Liste im Hintergrund wegzuschmeißen!
        sheets: (state.sheets || []).map(s => {
          const currentName = s.safe_sheet_name || s.safeSheetName || "";
          
          // Nur wenn der Name zu 100% übereinstimmt, patchen wir das Objekt im RAM
          if (currentName !== "" && currentName === payloadName) {
            return { 
              ...s, 
              ...payloadData // Überschreibt nur die geänderten Felder (Kategorie, etc.)
            };
          }
          // Alle anderen Lieder im Array bleiben völlig unangetastet!
          return s;
        })
      };
    }


    case RESET_DATA:
      return {
        ...state,
        composers: [],
        sheets: [],
        sheetPages: {},
        composerPages: {},
      };

    case "SET_COMPOSER_SORT_ORDER":
      return {
        ...state,
        composerSortOrder: action.payload,
      };

    case "SET_COMPOSER_VIEW_MODE":
      return {
        ...state,
        composerViewMode: action.payload,
      };

    case "SET_SHEET_SORT_ORDER":
      return {
        ...state,
        sheetSortOrder: action.payload,
      };

    case "SET_SHEET_VIEW_MODE":
      return {
        ...state,
        sheetViewMode: action.payload,
      };

    case "SET_SHEET_PAGE_SIZE":
      return {
        ...state,
        entrysPerSheetPage: action.payload,
      };

    case "SET_COMPOSER_PAGE_SIZE":
      return {
        ...state,
        entrysPerComposerPage: action.payload,
      };

    default:
      return state;
  }
}

export default dataReducer;
